import React from "react";
import ColorButton from "../common/ColorButton";
import TSTable from "../common/TSTable";
import { Layout, theme, Descriptions, Checkbox } from 'antd';
import {
  PrinterOutlined,
  DownloadOutlined
} from '@ant-design/icons';
import HeaderScreen from "../common/HeaderScreen";
import * as _ from "lodash";
import { Content } from "antd/es/layout/layout";
import PurchaseLoadTankModal from "../components/purchase/PurchaseLoadTankModal";

export default function PurchaseSendProductScreen() {
  const [ openLoadTankModal, setOpenLoadTankModal] = React.useState(false)
  const { token : { colorSuccess, colorPrimary, colorWarning } } = theme.useToken();

  const mockUserData = [{

  }]

  const item = [
    {
      key: '1',
      label: 'ทะเบียนรถ',
    },
    {
      key: '2',
      label: 'น้ำหนักขาย',    
    },
  ]

  const columns = [
    {
      title : 'แสดง Lot ในรายงาน',
      dataIndex : '',
      render : () => {
        <center>
          <Checkbox onChange={() => {}}/>
        </center>
      }
    },
    {
      title : 'วันที่',
      dataIndex : 'no',
    },
    {
      title : 'Lot NO.',
      dataIndex : 'seal_no',
    },
    {
      title : 'น้ำหนัก Load',
      dataIndex : 'licence',
    },
  ]


	return(
    <Layout>
      <HeaderScreen title={"รายการสั่งซื้อ - > ใบส่งสินค้าตู้ -"}/>
      <Content
        style={{
          margin: 24,
          minHeight: 280,
          padding: "0px 24px",
      }}>
        <Descriptions
          bordered
          column={2}
          size={"small"}
          items={item}
          style={{marginBottom : 15}}
        />  
          <ColorButton 
            type={"primary"} 
            size={"medium"} 
            override={colorSuccess} 
            icon={<DownloadOutlined /> } 
            style={{float : 'right', marginRight : 10, marginBottom : 15}}
            onClick={() => setOpenLoadTankModal(true)}
          >
            {"Load แทงก์"}
          </ColorButton>
          <ColorButton 
            type={"primary"} 
            size={"medium"} 
            override={colorSuccess} 
            icon={<PrinterOutlined />}
            style={{float : 'right', marginRight : 10, backgroundColor : "#48CAE4"}}
            onClick={() => {}}
          >
            {"พิมพ์ใบส่งสินค้า"}
          </ColorButton>
        <TSTable
          columns={columns}
          data={mockUserData}
          hidePagination={true}
        />
      </Content>

      <PurchaseLoadTankModal
        open={openLoadTankModal}
        onClose={() => setOpenLoadTankModal(false)}
      />
    </Layout>
)
}